import camelCase from 'lodash/camelCase';

const getter = getters => {
  let data = { };
  const requireModule = require.context('../store/modules/', false, /\.js$/);
  requireModule.keys().forEach(filename => {
    if (filename === './index.js') return;
    const moduleName = camelCase(filename.replace(/(\.\/|\.js)/g, ''));
    data[moduleName] = getters[moduleName + '/data'];
  });
  return data;
};
const createGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
const formattedTime = (jobtime, localizationTextslanguage) => {
  const hours = jobtime / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  const textHours = rhours > 1 ? localizationTextslanguage.general.time.hours : localizationTextslanguage.general.time.hour;
  const textMinutes = minutes > 1 ? localizationTextslanguage.general.time.minutes : localizationTextslanguage.general.time.minute;

  let formattedTime = '';
  if (rhours > 0) {
    formattedTime += rhours + ' ' + textHours + ' ';
  }
  if (rminutes > 0) {
    formattedTime += rminutes + ' ' + textMinutes + ' ';
  }

  return formattedTime;
};
const postGTM = (dataLayerData, host) => {
  let currentHost = host;
  if (host === '') {
    currentHost = document.location.origin;
  }
  parent.postMessage({ action: 9, namespace: 'bt', data: dataLayerData }, currentHost);
  return true;
};
const postScroll = (container, offset, host) => {
  let currentHost = host;
  if (host === '') {
    currentHost = document.location.origin;
  }
  parent.postMessage({ action: 8, namespace: 'bt', id: container, offset: offset }, currentHost);
  return true;
};

const sendRefresh = host => {
  parent.postMessage({ action: 10, namespace: 'bt' }, host);
};

const postRedirect = (host, url) => {
  parent.postMessage({ action: 7, namespace: 'bt', data: {url: url} }, host);
};

const sendGTM = postGTM;
const sendScroll = postScroll;
const sendRedirect = postRedirect;

export default {
  sendRefresh,
  getter,
  formattedTime,
  createGuid,
  sendGTM,
  sendScroll,
  sendRedirect
};
